<template>
  <section class="page-card">
    <h1 class="page-title">{{ $t('pages.commission') }}</h1>

    <div class="summary-grid wallet-grid">
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.earningsWalletBalance') }}</div>
        <div class="metric-value">{{ wallet.earnings_balance || '0' }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.totalEarnings') }}</div>
        <div class="metric-value">{{ wallet.total_earnings || '0' }}</div>
      </div>
    </div>

    <div class="summary-grid">
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.month') }}</div>
        <div class="metric-value">{{ data.month || '-' }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.packageName') }}</div>
        <div class="metric-value small">{{ data.pkg || '-' }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('pages.teamSuccessfulRecharge') }}</div>
        <div v-if="currencyDetails.length" class="metric-list">
          <div v-for="item in currencyDetails" :key="`${item.source_type || 'NORMAL_RECHARGE'}:${item.source_currency || ''}`" class="metric-row">
            <span>{{ item.source_currency || '-' }}</span>
            <strong>{{ item.source_amount }}</strong>
          </div>
        </div>
        <div v-else class="metric-value">0</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('pages.convertedTurnover') }} {{ data.currency_code }}</div>
        <div class="metric-value">{{ data.settlement_recharge_amount || '0' }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.commission') }} {{ data.currency_code }}</div>
        <div class="metric-value">{{ data.commission_amount || '0' }}</div>
      </div>
    </div>

    <el-alert
      v-for="item in warnings"
      :key="item.currency"
      type="warning"
      :closable="false"
      :title="item.currency + ': ' + item.message"
      class="warning-line"
    ></el-alert>

    <h2 class="section-title">{{ $t('common.currentCommissionRules') }}</h2>
    <div class="table-scroll">
      <el-table :data="rules" border stripe>
        <el-table-column prop="min" :label="$t('common.min')" min-width="100"></el-table-column>
        <el-table-column prop="max" :label="$t('common.max')" min-width="100">
          <template slot-scope="scope">{{ scope.row.max || $t('common.noLimit') }}</template>
        </el-table-column>
        <el-table-column prop="rate" :label="$t('common.ratePercent')" min-width="100"></el-table-column>
      </el-table>
    </div>

    <h2 class="section-title">{{ $t('pages.currencyDetails') }}</h2>
    <div class="table-scroll">
      <el-table :data="currencyDetails" border stripe>
        <el-table-column prop="source_currency" :label="$t('common.sourceCurrency')" min-width="120"></el-table-column>
        <el-table-column prop="source_type" :label="$t('common.sourceType')" min-width="150"></el-table-column>
        <el-table-column prop="source_amount" :label="$t('common.sourceAmount')" min-width="130"></el-table-column>
        <el-table-column prop="target_currency" :label="$t('common.targetCurrency')" min-width="130"></el-table-column>
        <el-table-column prop="exchange_rate" :label="$t('common.exchangeRate')" min-width="120"></el-table-column>
        <el-table-column prop="target_amount" :label="$t('common.targetAmount')" min-width="130"></el-table-column>
      </el-table>
    </div>

    <h2 class="section-title">{{ $t('pages.tierDetails') }}</h2>
    <div class="table-scroll">
      <el-table :data="tierDetails" border stripe>
        <el-table-column prop="min" :label="$t('common.min')" min-width="100"></el-table-column>
        <el-table-column prop="max" :label="$t('common.max')" min-width="100">
          <template slot-scope="scope">{{ scope.row.max || $t('common.noLimit') }}</template>
        </el-table-column>
        <el-table-column prop="rate" :label="$t('common.ratePercent')" min-width="100"></el-table-column>
        <el-table-column prop="tier_amount" :label="$t('common.hitTurnover')" min-width="130"></el-table-column>
        <el-table-column prop="commission_amount" :label="$t('common.commission')" min-width="130"></el-table-column>
      </el-table>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Commission',
  data() {
    return {
      data: {},
      wallet: {},
      rules: [],
      currencyDetails: [],
      tierDetails: [],
      warnings: []
    };
  },
  created() {
    this.loadData();
    this.loadWallet();
  },
  methods: {
    async loadWallet() {
      const resp = await this.$axios.get('/admin/exagent/console/wallet/');
      if (resp.data.status !== 0) return;
      this.wallet = resp.data.data || {};
    },
    async loadData() {
      const resp = await this.$axios.get('/admin/exagent/console/commission/');
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.data = data;
      this.rules = data.rules || [];
      this.currencyDetails = data.currency_details || [];
      this.tierDetails = data.tier_details || [];
      this.warnings = data.warnings || [];
    }
  }
};
</script>

<style lang="less" scoped>
.section-title {
  margin: 18px 0 10px;
  font-size: 15px;
  font-weight: 700;
}

.warning-line {
  margin-bottom: 8px;
}

.wallet-grid {
  margin-bottom: 16px;
}

.metric-value.small {
  font-size: 16px;
  word-break: break-all;
}

.metric-list {
  margin-top: 8px;
}

.metric-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 26px;
  color: #20283a;

  span {
    color: #66788a;
    font-size: 13px;
  }

  strong {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Commission.vue